export default {
    PLACES_INPUT_CHANGE: 'retailer-places-input-change',
};
